import { render } from "./EmojiPicker.vue?vue&type=template&id=dc5eb3a6&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"

import "./EmojiPicker.vue?vue&type=style&index=0&id=dc5eb3a6&scoped=true&lang=scss"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5eb3a6"]])

export default __exports__